export default "__VITE_ASSET__ZuZiGB7p__"